import Http from '@/services/httpCommunity'

// The Mundo Gamer network's own brand/regional accounts (Agency, Network,
// Network UAE, TV, ...) that admins can publish feed posts/stories as.
export const getNetworkAccounts = () => Http.get('/network-accounts')
